import React from 'react';
import CapRow from '../CapRow';
import CapDivider from '../CapDivider';

const Divider = () => (
  <CapRow className="divider-row">
    <CapDivider className="divider-horizontal" />
  </CapRow>
);

export default Divider;
